import Avatar from './src/main';

Avatar.install = function(Vue) {
  Vue.component(Avatar.name, Avatar);
};

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/avatar/index.js